import React from "react";
import { ConnectMovmoButton } from "@movmo/connect-button";
import "@movmo/connect-button/dist/index.css";
import {
    CONNECT_BUTTON_CLIENT_ID,
    CONNECT_BUTTON_REDIRECT_URI,
} from "./config";

/**
 * Local test surface for @movmo/connect-button.
 *
 * Click the button → full-page redirect to auth.e2e.movmo.io → sign in →
 * redirect back to /connect-button/callback. The callback page validates state
 * via completeMovmoOAuth() and exchanges the code for tokens (proxied through
 * setupProxy.js to bypass browser CORS).
 *
 * The DCR client_id below was registered against e2e for this exact redirect
 * URI. DCR client registrations carry a 30-day sliding TTL — if you haven't
 * used it in a month it will have expired. To re-register:
 *
 *     curl -X POST https://e2e.api.movmo.io/v1/oauth/register \
 *       -H "Content-Type: application/json" \
 *       -d '{
 *         "redirect_uris": ["http://localhost:3000/connect-button/callback"],
 *         "client_name": "mock-airline-react-connect-test",
 *         "token_endpoint_auth_method": "none"
 *       }'
 *
 * Then update CONNECT_BUTTON_CLIENT_ID in ./config.ts (or set
 * REACT_APP_MOVMO_CONNECT_BUTTON_CLIENT_ID in .env.testing / .env.e2e).
 */
export default function ConnectButtonStart() {
    return (
        <div
            style={{
                minHeight: "100vh",
                background: "#f5f5f4",
                fontFamily:
                    "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
                padding: 40,
            }}
        >
            <div
                style={{
                    maxWidth: 720,
                    margin: "60px auto",
                    background: "#fff",
                    border: "1px solid #e7e5e4",
                    borderRadius: 12,
                    padding: 32,
                    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                }}
            >
                <h1
                    style={{
                        fontSize: 20,
                        margin: "0 0 8px",
                        color: "#1B2A4A",
                    }}
                >
                    @movmo/connect-button 1.0 — local test
                </h1>
                <p style={{ color: "#57534E", fontSize: 13, marginBottom: 24 }}>
                    Click the &quot;Checkout faster with Movmo&quot; chip to start the OAuth 2.0 PKCE flow against{" "}
                    <code>https://auth.e2e.movmo.io/</code> (the package&apos;s
                    isProd-derived default — no URL config). After signing
                    in, Movmo will redirect back to{" "}
                    <code>{CONNECT_BUTTON_REDIRECT_URI}</code>, where the
                    callback page will run <code>completeMovmoOAuth()</code> and
                    exchange the code for tokens.
                </p>
                <p style={{ color: "#57534E", fontSize: 13, marginBottom: 24 }}>
                    <strong>client_id:</strong>{" "}
                    <code>{CONNECT_BUTTON_CLIENT_ID}</code> (DCR public client,
                    30-day sliding TTL — see source comment to re-register if
                    expired)
                </p>
                <ConnectMovmoButton
                    clientId={CONNECT_BUTTON_CLIENT_ID}
                    redirectUri={CONNECT_BUTTON_REDIRECT_URI}
                    isProd={false}
                    onError={(err) =>
                        alert(`OAuth start error: ${err.message}`)
                    }
                />
            </div>
        </div>
    );
}
